import CompaniesService from '@/services/web/companies.service'

const actions = {
  PushControlToRefresh(context, controlName) {
    context.commit('PUSH_CONTROL_TO_REFRESH', controlName);
  },

  RemoveControlFromRefresh(context, controlName) {
    context.commit('REMOVE_CONTROL_FROM_REFRESH', controlName);
  },

  setCompanyUnits(context) {
    CompaniesService.get(context.state.tokenService.idCompany(), null, null, null, null)
    .then(response  => {
      if (response.data != null && response.data.data != null) {
        let company = response.data.data[0]
        context.commit('SET_COMPANY_UNITS', company.countUnits);
      }
    }).catch( exc => {
        console.log('action - setCompanyUnits() ' + exc)
    })
  },
  setTokenService(context, tokenService) {
    context.commit('SET_TOKEN_SERVICE', tokenService);
  }
}

export default actions